import { LOCATION_CHANGE } from 'connected-react-router';
import union from 'lodash/union';

import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import { ADD_LOCAL_ERROR_CODES, RESET_ERROR_CODES } from '../actions/otpForm';
import { SEND_OTP_CODE } from '../actions/sendOtpCode';
import { RESEND_OTP_CODE } from '../actions/resendOtpCode';

const defaultState = {
  status: requestsStatuses.default,
  errorCodes: [],
  previousLocation: '',
  currentLocation: null,
};

export default createReducer(defaultState, {
  [RESEND_OTP_CODE.failure]: (state, { payload: { apiErrorCodes } }) => ({
    ...state,
    status: requestsStatuses.failure,
    errorCodes: union(state.errorCodes, apiErrorCodes),
  }),

  [SEND_OTP_CODE.failure]: (state, { payload: { apiErrorCodes } }) => ({
    ...state,
    status: requestsStatuses.failure,
    errorCodes: union(state.errorCodes, apiErrorCodes),
  }),
  [SEND_OTP_CODE.pending]: (state) => ({
    ...state,
    status: requestsStatuses.pending,
    errorCodes: [],
  }),
  [SEND_OTP_CODE.success]: (state) => ({
    ...state,
    status: requestsStatuses.success,
    errorCodes: [],
  }),

  [ADD_LOCAL_ERROR_CODES]: (state, { meta: { errorCodes } }) => ({
    ...state,
    errorCodes: union(state.errorCodes, errorCodes),
  }),

  [RESET_ERROR_CODES]: (state) => ({
    ...state,
    status: requestsStatuses.default,
    errorCodes: [],
  }),

  [LOCATION_CHANGE]: (state, action) => ({
    ...defaultState,
    previousLocation: state.currentLocation,
    currentLocation: action.payload.location.pathname,
  }),

});
